export default "__VITE_ASSET__DysG6baL__"